import { IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
  production: true,
  devTool: false,
  baseUrls: {
    serviceSecurity: 'https://wabtec.siliconexpert.com',
    serviceURL: 'https://wabtec.siliconexpert.com/api/v1',
   },
   ConfigParams: {
    infoUserEmail: 'gerardo.navarro@wabtec.com',
    infouser: 'Gerardo Navarro',
    projectName:'wabtec',
    domain:'https://wabtec.siliconexpert.com'
   },
  powerBiReports: {
    dashboardReportId: '4c92e06a-a325-4629-a31b-d9773e5439e5',
  },
};
